{
  "title": "Security",
  "description": "Manage your password, two-factor authentication, and active sessions.",

  "passwordTitle": "Change password",
  "passwordDescription": "Use a strong, unique password to keep your account secure.",
  "currentPasswordLabel": "Current password",
  "newPasswordLabel": "New password",
  "confirmPasswordLabel": "Confirm new password",
  "passwordHelper": "Use at least 8 characters.",
  "changePassword": "Update password",
  "passwordChanged": "Password updated",
  "passwordChangedDescription": "Your password has been changed.",
  "passwordError": "We couldn't change your password.",
  "passwordErrorDescription": "Check your current password and try again.",

  "twoFactorTitle": "Two-factor authentication",
  "twoFactorDescription": "Add a second step at sign-in for an extra layer of protection.",
  "twoFactorDisabled": "Not enabled",
  "twoFactorEnabled": "Enabled",
  "twoFactorHint": "Use an authenticator app to generate one-time codes.",
  "enableTwoFactor": "Enable two-factor",
  "disableTwoFactor": "Turn off 2FA",
  "regenerateCodes": "Regenerate codes",

  "setupDialogTitle": "Set up two-factor authentication",
  "setupDialogDescription": "Scan the QR code with your authenticator app, then enter the 6-digit code to confirm.",
  "qrAlt": "QR code for your authenticator app",
  "secretLabel": "Or enter this key manually",
  "verifyCodeLabel": "6-digit code",
  "verify": "Verify and enable",
  "verifyError": "That code didn't match.",
  "verifyErrorDescription": "Check your authenticator app and try again.",
  "setupError": "We couldn't start setup.",
  "setupErrorDescription": "Try again in a moment.",

  "recoveryTitle": "Save your recovery codes",
  "recoveryDescription": "Store these somewhere safe. Each code works once if you lose access to your authenticator. They will not be shown again.",
  "copyCodes": "Copy codes",
  "downloadCodes": "Download codes",
  "codesCopied": "Recovery codes copied",
  "recoveryDone": "I've saved my codes",

  "passwordPromptLabel": "Confirm with your password",
  "disableConfirmTitle": "Turn off two-factor authentication?",
  "disableConfirmBody": "Your account will rely on your password alone. Enter your password to confirm.",
  "disableConfirm": "Turn off 2FA",
  "twoFactorDisabledToast": "Two-factor disabled",
  "twoFactorDisabledToastDescription": "Two-factor authentication is now off.",
  "disableError": "We couldn't turn off two-factor.",
  "regenerateConfirmTitle": "Regenerate recovery codes?",
  "regenerateConfirmBody": "Your existing recovery codes will stop working. Enter your password to confirm.",
  "regenerateConfirm": "Regenerate codes",
  "regenerateError": "We couldn't regenerate your codes.",

  "sessionsTitle": "Active sessions",
  "sessionsDescription": "Devices currently signed in to your account.",
  "sessionsEmptyTitle": "No other active sessions",
  "sessionsEmptyDescription": "When you sign in from another device, it will show up here.",
  "currentSession": "Current",
  "unknownDevice": "Unknown device",
  "signedInAt": "Signed in {{date}}",
  "ipLabel": "IP {{ip}}",
  "revoke": "Revoke",
  "revokeConfirmTitle": "Sign out this session?",
  "revokeConfirmBody": "This device will be signed out and will need to log in again.",
  "revokeConfirm": "Sign out",
  "sessionRevoked": "Session revoked",
  "sessionRevokedDescription": "That device has been signed out.",
  "revokeError": "We couldn't revoke that session.",
  "revokeErrorDescription": "Try again in a moment.",
  "sessionsError": "We couldn't load your sessions.",

  "passwordRequired": "Enter your current password.",
  "passwordTooShort": "Use at least 8 characters.",
  "passwordMismatch": "The new passwords don't match.",
  "codeRequired": "Enter the 6-digit code.",
  "passwordPromptRequired": "Enter your password to confirm."
}
